import React from "react"
import './style.scss'

export default function Loading() {
    return <div className="Loading">
        Loading...
    </div>
}